// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import articlesReducer from './slices/articlesSlice';
import authReducer from './slices/authSlice';
import chitalishtaReducer from "./slices/chitalishtaSlice";
import feedbackReducer from './slices/feedbackSlice';
import adminFeedbackReducer from './slices/adminFeedbackSlice';
import chitalishteAdminReducer from './slices/chitalishteAdminSlice';
import libraryReducer from './slices/librarySlice';
import auditLogReducer from './slices/auditLogSlice';
import libraryAdminReducer from './slices/libraryAdminSlice';
import { setupInterceptors } from '../services/api';

export const store = configureStore({
  reducer: {
    articles: articlesReducer,
    auth: authReducer,
    chitalishta: chitalishtaReducer,
    feedback: feedbackReducer,
    adminFeedback: adminFeedbackReducer,
    chitalishteAdmin: chitalishteAdminReducer,
    libraries: libraryReducer,
    auditLogs: auditLogReducer,
    libraryAdmin: libraryAdminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/login/fulfilled', 'auth/login/rejected'],
        ignoredPaths: ['auth.error'],
      },
    }),
});

setupInterceptors(store);